import { Button } from '@mui/material'
import React from 'react'
import styled from 'styled-components'

const SingleProjectStyle = styled.div`
    .projects__img{
        width: 250px;
        border-radius: 0.75rem;
        margin-bottom: 1.25rem;
    }
    & > div{
        .projects__subtitle{
            font-size: var(--small-font-size);
            color: var(--text-color-light);
        }
        .projects__title{
            font-size: var(--h2-font-size);
            margin-bottom: 1.25rem;
            margin: .5rem 0 1.25rem
        }
        .projects__button{
            display: inline-flex;
            align-items: center;
            column-gap: .5rem;
            color: var(--title-color);
            font-size: var(--small-font-size);

            i{
                font-size: 1rem;
                transition: transform 0.3s
            }
            &:hover{
                
                i{
                    transform : translateX(.25rem);
                }
            }
        }
    }
    
    @media screen and (max-width: 340px){
        .projects__img{
            width: 180px;
            justify-self: center;
        }

        & > div{
            .projects__title{
                font-size: var(--normal-font-size);
            }
            .projects__subtitle{
                font-size: var(--smaller-font-size);
            }
            .projects__button{
                font-size: var(--smaller-font-size)
            }
        }
    }
    @media screen and (min-width: 767px){
        .projects__img{
            width: 450px;
        }
    }
`

function SingleProject({ heroimg, name, subtitle, setTitle, setPimg, setDesc, setLinks, setStacks, item, handleClickOpen }) {
    return (
        <SingleProjectStyle>
            <img src={heroimg} className="projects__img" alt="realstore-ecommerce" />

            <div>
                <span className="projects__subtitle">{subtitle}</span>
                <h1 className="projects__title">{name}</h1>

                <Button className='projects__button' onClick={() => {
                    setTitle(item.title);
                    setPimg(item.heroimg);
                    setStacks(item.stacks);
                    setLinks(item.links);
                    setDesc(item.desc);
                    handleClickOpen();
                }}>
                    View Details
                    <i className='ri-arrow-right-line'></i>
                </Button>
            </div>
        </SingleProjectStyle>
    )
}

export default SingleProject